export default {
    data() {
        return {

        };
    },

    methods: {

    },

    computed: {
        ERPConfig() {
            return this.$store.getters['ERPConfig'];
        },
        ERPBaseAssembly() {
            return this.ERPConfig.ERPBaseAssembly;
        },
        ERPFriendlyName() {
            return this.ERPConfig.ERPFriendlyName;
        },
        CustomerReadonly() {
            return this.ERPConfig.CustomerReadonly === false ? false : true;
        },
        CustomerAddressReadonly() {
            return this.ERPConfig.CustomerAddressReadonly === false ? false : true;
        },
        CustomerPersonsReadonly() {
            return this.ERPConfig.CustomerPersonsReadonly === false ? false : true;
        },
        SupplierReadonly() {
            return this.ERPConfig.SupplierReadonly === false ? false : true;
        },
        EmploymentReadonly() {
            return this.ERPConfig.EmploymentReadonly === false ? false : true;
        },
    },
}